/**
 * WhatsApp Channel URL Helper
 *
 * Menggunakan URL pendek bit.ly yang dapat diakses dari semua device
 * (desktop, tablet, maupun mobile) tanpa perlu deteksi platform.
 */

export const WA_CHANNEL_URL = 'https://bit.ly/3QzpAyL';

/**
 * Mengembalikan URL WhatsApp Channel.
 */
export function getWaChannelUrl() {
  return WA_CHANNEL_URL;
}

/**
 * Komponen <a> siap pakai untuk link WhatsApp Channel.
 */
export function WaChannelLink({ className, children, style }) {
  return (
    <a
      href={WA_CHANNEL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
    >
      {children}
    </a>
  );
}
